import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import store from '@/store';

class Notification {

  async setNotification() {
    const schools = await JSON.parse(window.localStorage.getItem('preferences')).schools || []

    store.state.profile.isNotified = await PushNotifications.checkPermissions()
    
    await PushNotifications.register();
    
    if (store.state.profile.isNotified.receive === 'granted') {

      FCM.getToken()
      .then((r) => {
        //console.log('FCM Token = ', r.token)
        const res = store.dispatch('profile/registerDeviceNotification', {registration_id: r.token})
        if (res) {
          //console.log(res)
        }
      })
      .catch(err => console.log(err));

      schools.forEach((school) => {
        school.users.forEach((user) => {
          FCM.subscribeTo({ topic: `${school.code}-${user.role}` })
        })
      })
    } else {
      FCM.getToken()
      .then((r) => {
        //console.log('FCM Token = ', r.token)
        const res = store.dispatch('profile/unregisterDeviceNotification', {registration_id: r.token})
        if (res) {
          //console.log(res)
        }
      })
      .catch(err => console.log(err));

      schools.forEach((school) => {
        school.users.forEach((user) => {
          FCM.unsubscribeFrom({ topic: `${school.code}-${user.role}` })
        })
      })
    }
  }

  async logout(code, role) {

    store.state.profile.isNotified = await PushNotifications.checkPermissions()
    
    await PushNotifications.register();
    await FCM.getToken()
    .then(async (r) => {
      //console.log('FCM Token = ', r.token)
      const res = await store.dispatch('profile/unregisterDeviceNotification', {registration_id: r.token})
      if (res) {
        //console.log(res)
      }
    })
    .catch(err => console.log(err));

    await FCM.unsubscribeFrom({ topic: `${code}-${role}` })

    return true
    
  }
}

export default new Notification()